import { BaseApiService } from '@/services/base-service';
import { AxiosResponse } from 'axios';
import { MaterialsFilters } from '../types';

export class MaterialsService extends BaseApiService {
  private readonly base_path = 'marketing-materials';
  private readonly url_path = 'marketing-material-urls';

  private downloadingAbortController: AbortController | null = null;

  async show(id: string) {
    const { data } = await this.http_client.get(`${this.url_path}/${id}`);

    return data;
  }

  async first_or_create(filters: MaterialsFilters) {
    const { data } = await this.http_client.post(`${this.url_path}`, filters);

    return data;
  }

  async download(path: string, onDownloadProgress?: (progressEvent: ProgressEvent) => void): Promise<AxiosResponse<Blob>> {
    this.downloadingAbortController = new AbortController();
    return this.http_client.post(
      `${this.base_path}/download`,
      { path },
      {
        timeout: Infinity,
        responseType: 'blob',
        onDownloadProgress,
        signal: this.downloadingAbortController.signal,
      },
    );
  }

  cancelDownload() {
    if (this.downloadingAbortController) {
      this.downloadingAbortController.abort();
    }
  }
}
